<template>
  <div class="box14">
    <pageTitle title="免费课程" text />

    <commonFreeVideo class="box" :videoList="videoList" pageName="产品经理-就业课" />

    <!-- <div class="btn" @click="toLink('https://m.boxuegu.com/')"> -->
    <div class="btn" @click="zixun('获取更多')">
      获取更多
      <span>></span>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commonFreeVideo from "../common/common-free-video.vue";
export default {
  components: {
    pageTitle,
    commonFreeVideo,
  },
  data() {
    return {
      videoList: [
        {lessonName:"Axure RP零基础入门到精通",
          url: "https://www.boxuegu.com/freecourse/detail-1449.html",
          img: require("../../../assets/coursePage/pm/box13/01.png"),
        },
        {lessonName:"产品经理入门课",
          url: "https://www.boxuegu.com/freecourse/detail-4557.html",
          img: require("../../../assets/coursePage/pm/box13/02.png"),
        },
        {lessonName:"产品原型设计",
          url: "https://www.boxuegu.com/freecourse/detail-4523.html",
          img: require("../../../assets/coursePage/pm/box13/03.png"),
        },
        {lessonName:"Axure 9入门到进阶",
          url: "https://www.boxuegu.com/freecourse/detail-4522.html",
          img: require("../../../assets/coursePage/pm/box13/04.png"),
        },
      ],
    };
  },
  methods: {
    zixun(name) {
      this.mai("产品经理-就业课","获取更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box14 {
  padding: 80px 0px 88px;
  width: 100%;
  overflow: hidden;
  .box {
    margin-top: 48px;
  }
  .btn {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #6e73ff;
  }
}
</style>
